import { createMuiTheme } from '@material-ui/core/styles';

const theme = createMuiTheme({
  palette: {
    primary: { main: '#FFAB00', light: 'rgba(0, 0, 0, 0.87)', dark: '#FFAB00' },
    secondary: { main: '#757575' },
    error: { main: 'rgb(221,44,0)' }
  },
  typography: {
    fontFamily: '"Lato", sans-serif'
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/app/admin/muiTheme.js